module.exports = __webpack_public_path__ + "static/media/theme-73.4d4647df.jpg";